<template>
  <div id="publicSettingDiv">
    <div class="publicSettingDiv_content">
      <div class="publicSetting_head_title">
        <div class="head_title_font publicSetting_head_title_font">
          校内教师
        </div>
        <div class="searcharea">
          <input type="text" class="form-control" style="display: inline-block;width: 200px" placeholder="姓名或在授课程" v-model="searchName">
          <button type="button" class="btn btn-default btn_option" @click="initDescriptionListData()">查询</button>
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#myModal" @click="option_flag='add'">+ 新增</button>
        </div>
      </div>


      <div class="row">
        <div class="class_body_content_self col-xs-8 col-md-8">
          <table class="table table-striped table-bordered msgTb">
            <thead>
            <tr>
              <th width="5%">#</th>
              <th width="20%">照片</th>
              <th>姓名/描述</th>
              <th width="8%">顺序</th>
              <th width="18%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(Description, index) in DescriptionList" :key="index" @click="loadCourseData(Description.dataId)" :class="{selected:editTeacherId && editTeacherId==Description.dataId}">
              <td width="5%">
                {{index+1}}
              </td>
              <td width="20%"><a class="picbox" @click="openImageModal(att.filePath)" href="#"  v-for="(att, index) in Description.attachments">
                <img :src="resourcePath + att.filePath" style="height: 100px;width: 80px;"/>
                <div class="glyphicon glyphicon-remove" @click.stop="deleteAttachmentsFile(att.id)"></div>
              </a></td>
              <td>
                <b>{{Description.name}}</b>
                <div class="description-content" :title="Description.content">
                  {{Description.content}}
                </div>
              </td>
              <td width="8%">{{Description.order}}</td>
              <td width="18%">
                <div class="upload_pic" @click.stop="uploadPic(index)"></div>
                <div class="edit_pic" @click.stop="option_flag='update';updateMsgSetting(index)"></div>
                <div class="delete_pic" @click.stop="deleteDescription(Description.id)"></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-xs-4 col-md-4">
          <div class="teacher_top">
            <span>在授课程</span>
          </div>
          <table class="table table-striped table-bordered msgTb">
            <tbody>
            <tr v-for="(d, index) in courseList" :key="index">
              <td>{{d.name}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 新增模态框（Modal） -->
    <div class="modal fade" id="uploadModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" >
              图片上传
            </h4>
          </div>
          <div class="modal-body">
            <!--上传-->
                       <uploader :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploader">
                          <uploader-unsupport></uploader-unsupport>
                          <uploader-drop>
                            <p>拖拽文件至此处</p>
                            <uploader-btn :attrs="upload.attrs.image">选择图片</uploader-btn>
                          </uploader-drop>
                          <uploader-list></uploader-list>
                        </uploader>
          </div>
        </div>
      </div>
    </div>

     <!-- 新增模态框（Modal） -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">
              {{option_flag=="add"?'新增':'编辑'}}
            </h4>
          </div>
          <div class="modal-body">
            <!--上传-->
<!--            <uploader :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploader">
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <p>拖拽文件至此处</p>
                <uploader-btn :attrs="upload.attrs.image">选择图片</uploader-btn>
              </uploader-drop>
              <uploader-list></uploader-list>
            </uploader>


            <div class="editImageDiv" v-if="option_flag == 'update'">
              <label>历史上传附件：</label>
              <p class="fileListP" v-for="(att, index) in edit_current_file_data" :key="index">
                <a @click="openImageModal(att.filePath)">{{att.fileName}}</a>
                <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile(att.id)"></span>
              </p>
            </div>


            <br>-->
            <input type="text" class="form-control" v-validate="'required|maxL:50'" data-vv-scope="teachers" data-vv-as="教师姓名" name="title" placeholder="教师姓名"
                   v-model="searchTeacherName" @keyup.enter="addTeacher(0)" @keyup.up="addTeacher(-1)" @keyup.down="addTeacher(1)"  @keyup="loadQueryInputDataWhenAdd($event)" @focus="loadQueryInputDataWhenAdd()" autocomplete="off">
            <span class="spanRed">*</span>
            <span class="validateTip">{{ errors.first('teachers.title') }}</span>
            <div id="teachers_div">
              <option v-for="(queryData, index) in queryInputDataArr" :key="index" :value="queryData.userName" :class="index != selectedIndex||'selected'"
                      @click="chooseTeachers(queryData.id,queryData.userName)">{{queryData.userName}}-{{queryData.mobile}}</option>
            </div>
<!--            <br>
            <select class="form-control" v-model="description.type">
              <option value="2">校内教师风采</option>
              <option value="1">党校介绍</option>
              <option value="3">校外教师风采</option>
            </select>-->
            <br>
            <input type="number" class="form-control" v-validate="'required'" data-vv-scope="teachers" data-vv-as="顺序" name="sorting" placeholder="顺序" v-model="description.order">
            <span class="spanRed">*</span>
            <span class="validateTip">{{ errors.first('teachers.sorting') }}</span>
            <br>
            <textarea class="form-control description-textarea" placeholder="描述内容" rows="20" v-model="description.content" style="resize: none"></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="modalClickOk()">保存</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>

    <!--图片显示-->
    <div class="modal fade" id="myModal_showImage" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showImage" aria-hidden="true" data-backdrop='static'>
      <div class="modal-dialog modal-dialog-look">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              &times;
            </button>
            <h4 class="modal-title" id="myModalLabel_showImage">
              图片预览
            </h4>
          </div>
          <div class="modal-body modal-body-look">
            <img :src="description.filePath" class="previewImg"/>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import {getContentSize} from './mainView';
  import {schoolAxios} from "../main"

  export default {
    name: "msgSetting",

    data() {
      return {
        DescriptionList:[],

        option_flag: '',

        isUploadImage: false,
        isDeleteImage:false,
        resourcePath:  this.$store.state.serviceBase + "resources/",

        searchName: '',
        searchTeacherName:"",
        queryInputDataArr:[],
        selectedIndex: -1,
        searchTeacherNameComplete: false,
        teacherId:"",
        teacherName:"",
        description: {
          id: '',
          name: '',
          type: '2',
          content: '',
          order: '',
          fileName: '',
          filePath: '',
          attachments: '',
        },

        //上传ID
        attachmentIds: '',
        edit_current_file_data: [],

        //上传
        uploadIds: '',
        upload: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'upload/upload.action',
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
            },
            simultaneousUploads: 1,//同时上传数
            testChunks: false,
            chunkSize: 10*1024*1024*1024,//分片大小：10G
          },
          attrs: {
            image: {
              accept: 'image/*'
            },
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },
        courseList:[],
        editTeacherId:""
      }
    },
    filters: {
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //刷新页面首次加载
        this_.initDescriptionListData();

        //绑定加载关闭模态框时的事件
        this_.closeModal();

        //获得上传组件对象
        this_.upload.uploader = this_.$refs.uploader.uploader;
        //上传组件绑定事件
        this_.loadUpload();
      });
    },
    methods: {
      /**
       * 打开图片模态框
       */
      openImageModal(filePath) {
        let this_ = this;
        this_.description.filePath = this_.$store.state.serviceBase + "resources/" + filePath;
        $("#myModal_showImage").modal("show");
      },

      /**
       * 查询信息
       */
      initDescriptionListData() {
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'description/list',
          params: {
            name: this_.searchName,
            type:2
          },

        }).then(function (DescriptionListresp) {
          this_.DescriptionList = DescriptionListresp.data.list;
        });
      },
      modalClickOk(){
        let this_ = this;
        if(this_.option_flag == 'add'){
          this_.saveDescription();
        }else {
          this_.update_Description();
        }
      },
      saveDescription(){
        let this_ = this;
        /* let url = "";
           if(this_.option_flag == "add"){
             url = 'description/add';
           }else {
             url = 'description/edit';
           }*/
        this_.$validator.validateAll('teachers').then(result => {
          if (result) {
            if(!this_.teacherName || ! this_.teacherId){
              "教师必须从列表选择".showMessage();
              return;
            }
            schoolAxios({
              method: 'post',
              url: 'description/add',
              data: {
                id: this_.description.id,
                name: this_.teacherName,
                dataId:this_.teacherId,
                type: 2,
                content: this_.description.content,
                order: this_.description.order,
                // attachmentIds: this_.uploadIds,
                // attachmentIds: this_.attachmentIds,
              }
            }).then(function (resp) {
              let data = resp.data;
              console.info(data);
              "保存成功".showMessage();
              $("#myModal").modal("hide");
              this_.initDescriptionListData();
            })
          }
        });
      },
      deleteDescription(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'description/delete',
            params: {
              id: id,
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initDescriptionListData();
            }else{
              "删除失败".showMessage();
            }
          });
        });
      },
      /**
       * 修改信息
       */
      updateMsgSetting(index){
        let this_ = this;

        let my_data = this_.DescriptionList[index];

        this_.description = {
          id: my_data.id,
          name: my_data.name,
          dataId:my_data.dataId,
          type: my_data.type,
          content: my_data.content,
          order: my_data.order,
        };
        this_.teacherId = this_.description.dataId;
        this_.teacherName = this_.description.name;
        this_.searchTeacherName = this_.description.name;
        this_.searchTeacherNameComplete = true;
        $("#myModal").modal('show');

        //组装附件ID
        /* this_.splitAttachmentIds(my_data.attachmentId);
         let attachments = my_data.attachments;
         for(let i=0; i<attachments.length; i++){
           this_.splitAttachmentIds(attachments[i].id);
         }*/
      },
     /**
       * 上传图片
       */
     uploadPic(index){
        let this_ = this;

        let my_data = this_.DescriptionList[index];

        this_.description = {
          id: my_data.id
        };
        $("#uploadModal").modal('show');

      },

      deleteAttachmentsFile(id){
        let this_ = this;
        "确定删除图片吗？".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initDescriptionListData();
            }else{
              (data.message||"删除失败").showMessage();
            }
          })
        })
      },

      /**
       * 拼接附件ID
       */
      splitAttachmentIds(attachmentIds){
        let this_ = this;
        if(this_.attachmentIds != ""){
          this_.attachmentIds += ",";
        }
        this_.attachmentIds += attachmentIds;
      },

      /**
       * 修改信息
       */
      update_Description(index){
        let this_ = this;
        this_.$validator.validateAll('teachers').then(result => {
          if (result) {
            if(!this_.teacherName || ! this_.teacherId){
              "教师必须从列表选择".showMessage();
              return;
            }
            schoolAxios({
              method: 'post',
              url: 'description/edit',
              data: {
                'id': this_.description.id,
                'name': this_.teacherName,
                'dataId': this_.teacherId,
                'type': this_.description.type,
                'content': this_.description.content,
                'order': this_.description.order,
                // 'attachmentIds': this_.uploadIds,
                // 'attachmentIds': this_.attachmentIds,
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                "修改成功".showMessage();
                this_.isAddTeacher = false;
                this_.initDescriptionListData();
                $("#myModal").modal('hide');
              } else {
                data.message.showMessage();
              }
            });
          }
        });
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.description = {
            id: '',
            name: '',
            type: '2',
            content: '',
            order: '',
            filePath:'',
            fileName:'',
            attachments:'',
          };
          this_.searchTeacherNameComplete = false;
          this_.searchTeacherName = "";
          this_.selectedIndex = -1;
          this_.teacherId = "";
          this_.teacherName = "";

        });
        $("#uploadModal").on('hide.bs.modal', function () {
          this_.description = {
            id: '',
            name: '',
            type: '2',
            content: '',
            order: '',
            filePath:'',
            fileName:'',
            attachments:'',
          };

          if(this_.upload.uploader)
            this_.upload.uploader.cancel();
          this_.attachmentIds = "";
        });
        // $("#myModal_showImage").modal('hide');
        /*  $("#updateDescriptionModal").on('hide.bs.modal', function () {
            this_.description.name = '';
            this_.description.type = '';
            this_.description.content = '';
            this_.description.order = '';
          });*/
      },
      relationDescription(){
        let this_ = this;
        schoolAxios({
          method: 'post',
          url: 'upload/relation.action',
          data: {
            'formObjId': this_.description.id,
            'uploadAttachmentIds': this_.attachmentIds,
          }
        }).then(function (resp) {
          let data = resp.data;
          if (data.success) {
            "上传成功".showMessage();
            this_.initDescriptionListData();
            $("#uploadModal").modal('hide');
          }
        });
      },
      loadCourseData(id){
        this.editTeacherId = id;
        if(!id){
          "未绑定用户数据".showMessage();
          return;
        }
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'course/listByTeacher',
          params: {
            teacherId: id,
            teacherStatus: 1,
            status: 1
          },
        }).then(function (resp) {
          this_.courseList = resp.data.list;
        });
      },
      /**
       * 上传加载
       */
      loadUpload(){
        let this_ = this;
        this_.upload.uploader.on('fileAdded', function (file, event) {
          if(file.fileType.indexOf("image")==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        })
        this_.upload.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          //console.info(message);
          if(message){
            let message_ = JSON.parse(message);
            if(this_.uploadIds != ""){
              this_.uploadIds += ",";
            }
            this_.uploadIds += message_.message;
            if(this_.attachmentIds != ""){
              this_.attachmentIds += ",";
            }
            this_.attachmentIds += message_.message;
            this_.relationDescription();
          }
        })
        this_.upload.uploader.on('fileComplete', function (rootFile) {
          //console.info(rootFile);

        })
        this_.upload.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        })
      },
    addTeacher(opt){
      let this_ = this;
      if(opt == 0){
        if(this_.searchTeacherName){
          if(this_.selectedIndex >= 0 && this_.queryInputDataArr && this_.selectedIndex < this_.queryInputDataArr.length) {
            let d = this_.queryInputDataArr[this_.selectedIndex];
            this_.selectedIndex = -1;
            this_.chooseTeachers(d.id, d.userName);
            $("#teachers_div").hide();
          }
        }
        return;
      }

      if(this_.queryInputDataArr && this_.queryInputDataArr.length>0){
        if(opt == -1){
          if(this_.selectedIndex <= 0) return;
          else this_.selectedIndex -= 1;
        }else if(opt == 1){
          if(this_.selectedIndex == this_.queryInputDataArr.length-1) return;
          else this_.selectedIndex += 1;
        }
        this_.searchTeacherName = this_.queryInputDataArr[this_.selectedIndex].userName;
      }
    },
    /**
     * 联想查询班主任信息-add
     */
    loadQueryInputDataWhenAdd(event){
      let this_ = this;

      if(event && (event.keyCode == 13 //回车
        ||event.keyCode == 38//上键
        ||event.keyCode == 40 ))//下键
        return;
      if(this_.searchTeacherNameComplete && event && (event.keyCode == 8 || event.keyCode == 48 )){//选择后删除
        this_.searchTeacherNameComplete = false;
        this_.searchTeacherName = "";
        this_.selectedIndex = -1;
        this_.teacherId = "";
        this_.teacherName = "";
        return;
      }
        if (this_.searchTeacherName != "") {

          //后台查询数据赋值
          schoolAxios({
            method: 'get',
            url: 'user/queryUserSchoolByUserName',
            params: {
              'userName': this_.searchTeacherName
            }
          }).then(function (resp) {
            let data = resp.data;
            if (data.success) {
              this_.queryInputDataArr = data.list;
              $("#teachers_div").show();
            }
          });
        } else {
          this_.queryInputDataArr = [];
          $("#teachers_div").hide();
          this_.selectedIndex = -1;
          this_.teacherId = "";
          this_.teacherName = "";
        }
    },
      chooseTeachers(id,teacherName){
        let this_ = this;
        this_.teacherId = id;
        this_.teacherName = teacherName;
        this_.searchTeacherName = teacherName;
        this_.searchTeacherNameComplete = true;
        $("#teachers_div").hide();
      },

    },
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .class_head_title_self {
    width: 100%;
    height: 35px;
    line-height: 30px;
    border-bottom: 2px #B6B6B6 solid;
  }
  .class_head_title_font {
    width: 150px;
  }
  .query_div {
    margin-top: 90px;
  }
  .class_body_content_self {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .table {
    text-align: center;
  }
  .table-striped{
    background-color: #FFFFFF;
  }
  .table th {
    text-align: center;
    color: black;
    background-color: #cccccc;
  }

  .edit_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit.png");
    background-size: 100% 100%;
    float: left;
  }
  .upload_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/pic.png");
    background-size: 100% 100%;
    float: left;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete.png");
    background-size: 100% 100%;
    float: left;
  }
  .details_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/details.png");
    background-size: 100% 100%;
    float: left;
  }
  .edit_pic,.delete_pic,.details_pic,.upload_pic {
    margin: 0 2% ;
    cursor: pointer;
  }

  .uploader-drop {
    text-align: center;
  }

  .modal-body-look {
    text-align: center;
  }
  .modal-dialog-look {
    width: 60%;
  }
  /*表头固定*/
  .msgTb thead tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .msgTb tbody{
    /*display: block;*/
    height: 450px;
    /*overflow-y: scroll;*/
    overflow: auto;
  }
  .msgTb tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .msgTb{
    border: none;
  }
  .msgTb tbody::-webkit-scrollbar{
    width:0;
  }

  .editImageDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .editImageDiv span {
    float: right;
  }
  .fileListP {
    margin: 0 0 10px;
    height: 30px;
    line-height: 30px;
    font-size: 18px;
  }
  .fileListP a {
    color: black;
  }
  .form-control {
    display: inline-block;
    width: 95%;
  }
  .description-textarea {
    margin: 10px 0 0 0;

  }
.description-content{
  width: 100%;
  height: 70px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}
  .picbox{
    height: 102px;
    width: 82px;
    display: inline-block;
    position: relative;
  }
  .picbox div{
    position: absolute;
    top: 1px;
    right: 1px;
  }
  #teachers_div {
    position: absolute;
    left: 26px;
    width: 84%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1000;
  }
  #teachers_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #teachers_div option:hover , #teachers_div .selected{
    background-color: grey;
  }
  .searcharea{
    position: absolute;
    right: 0;
  }
  .teacher_top{
    margin: 20px 0;
  }
  .teacher_top span{
    display: inline-block;
    margin: 0 20px;
  }
  .selected, tr:hover{
    background-color: gray!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherManage.vue